export enum UniversityStatus {
    PUBLIC = 'Public',
    PRIVATE = 'Private'
}